<div class="analytics-card">
  <div class="card-body">
    <div class="card-header-section d-flex justify-content-between align-items-start mb-2">
      <h5 class="card-title mb-0">Threat Campaign Analysis</h5>
      @if (threatCampaignResponse()?.last_updated) {
        <div class="last-updated-indicator">
          <small class="text-muted">
            <span style="color: #64748b; font-weight: 400">Last updated:</span>
            {{ threatCampaignResponse()?.last_updated | date: 'short' }}
          </small>
        </div>
      }
    </div>

    @if (threatCampaignResponse(); as data) {
      <!-- Compact Metrics Grid -->
      <div class="metrics-grid-compact mb-3">
        <div class="metric-item-compact">
          <div class="metric-value-compact">{{ data.total_suspicious_senders }}</div>
          <div class="metric-label-compact">Suspicious Senders</div>
        </div>
        <div class="metric-item-compact">
          <div class="metric-value-compact">{{ data.top_sender_volume }}</div>
          <div class="metric-label-compact">Top Sender Volume</div>
        </div>
        @if (data.top_sender_velocity !== undefined) {
          <div class="metric-item-compact">
            <div class="metric-value-compact">{{ data.top_sender_velocity }}</div>
            <div class="metric-label-compact">Sender Velocity</div>
          </div>
        }
        @if (data.top_sender_role_spread !== undefined) {
          <div class="metric-item-compact">
            <div class="metric-value-compact">{{ data.top_sender_role_spread }}</div>
            <div class="metric-label-compact">Role Spread</div>
          </div>
        }
      </div>

      <!-- Top Suspicious Senders Chart -->
      <div class="chart-section">
        <h6 class="chart-title">Top 5 Suspicious Senders</h6>
        <div class="chart-container">
          <kendo-chart [style.height.px]="280">
            <kendo-chart-series>
              <kendo-chart-series-item
                type="bar"
                [data]="topSendersChartData()"
                field="volume"
                categoryField="sender"
                [color]="'#dc2626'"
                [labels]="{ visible: true, format: '{0}', position: 'outsideEnd' }"
              >
              </kendo-chart-series-item>
            </kendo-chart-series>
            <kendo-chart-category-axis>
              <kendo-chart-category-axis-item>
                <kendo-chart-category-axis-item-labels
                  [rotation]="0"
                  [font]="'11px Arial, sans-serif'"
                ></kendo-chart-category-axis-item-labels>
              </kendo-chart-category-axis-item>
            </kendo-chart-category-axis>
            <kendo-chart-value-axis>
              <kendo-chart-value-axis-item>
                <kendo-chart-value-axis-item-title text="Email Volume"></kendo-chart-value-axis-item-title>
                <kendo-chart-value-axis-item-labels
                  [font]="'11px Arial, sans-serif'"
                ></kendo-chart-value-axis-item-labels>
              </kendo-chart-value-axis-item>
            </kendo-chart-value-axis>
          </kendo-chart>
        </div>
      </div>

      <!-- Threat Indicators Section -->
      <div class="indicators-section-compact">
        <span class="indicators-label">Threat Indicators</span>
        <div class="indicators-value">{{ formattedIndicators() }}</div>
      </div>
    } @else {
      <!-- Loading/No Data State -->
      <div class="no-data-state">
        <p class="text-muted">No threat campaign data available</p>
      </div>
    }
  </div>
</div>
